export const PRIMARY_POSITION = 'a';
export const SECONDARY_POSITION ='b';
